import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import Ewaste from "../components/Ewaste";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const EwastePage = () => {
  return (
    <>
      <Helmet>
        <title>E-Waste | TimeWatch Infocom</title>
        <meta
          name="description"
          content="TimeWatch Infocom offers responsible and eco-friendly e-waste disposal solutions in Delhi. As part of our commitment to sustainability, we specialize in the safe recycling of electronic waste, including old biometric systems, access control devices, and security technology equipment. Our e-waste management services adhere to environmental regulations and ensure proper disposal of outdated security technologies. By choosing TimeWatch Infocom, you contribute to a greener future while safely recycling your electronic devices and components."
        />
        <link rel="canonical" href="https://www.timewatchindia.com/e-waste" />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="e-waste">
          <Ewaste />
        </section>
      </div>

      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default EwastePage;
